export default __webpack_public_path__ + "static/media/elan-row-white-flat.f5829824.png";